import React from "react"
import styled from "styled-components"
import Color from "../../../style/enum/color"
import { ChangeEvent } from "react"

interface IProps {
  onChange: (ev: ChangeEvent<HTMLSelectElement>) => void
  value: string | number
  options: Array<{
    key: string | number
    value: string | number
    name: string | number
  }>
  className?: string
}

export const StyledSelect = ({
  onChange,
  value,
  options,
  className,
}: IProps) => {
  return (
    <Wrapper className={className}>
      <Select onChange={onChange} value={value}>
        {options.map(option => (
          <option key={option.key} value={option.value}>
            {option.name}
          </option>
        ))}
      </Select>
    </Wrapper>
  )
}

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  &:after {
    content: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNC44IDgiPjxwYXRoIGQ9Ik0xNC43LjFjLS4yLS4xLS42LS4xLS43IDBMNy40IDYuNy44LjFDLjcgMCAuMyAwIC4xLjFTMCAuNy4xLjhMNyA3LjdjLjEuMS4yLjEuNC4xLjEgMCAuMyAwIC40LS4xTDE0LjcuOGMuMS0uMS4xLS41IDAtLjd6IiBmaWxsPSIjYjBiMGIwIi8+PC9zdmc+");
    color: ${Color.LIGHT_GRAY};
    width: 15px;
    height: 10px;
    right: 13px;
    top: 6px;
    position: absolute;
    pointer-events: none;
  }
`

export const Select = styled.select`
  padding: 8px 40px 8px 12px;
  border-radius: 4px;
  background: ${Color.WHITE};
  line-height: 1.3;
  color: ${Color.DIMGRAY};
  border: 1px solid ${Color.LIGHT_GRAY};
  width: 200px;
  display: inline-block;
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
`
